import { tenant } from '@tenant';

import { WebhookEventFormatsItem } from 'api';

export const ADD_WEBHOOK_FORM_ID = 'add-webhook-form';

export const ADD_WEBHOOK_MODAL_TEST_ID = 'developers_webhooks_add';
export const ADD_WEBHOOK_ENDPOINT_TEST_ID =
  'developers_webhooks_add_endpoint-input';
export const ADD_WEBHOOK_ENDPOINT_ERROR_TEST_ID =
  'developers_webhooks_add_endpoint-error';
export const ADD_WEBHOOK_BUSINESS_UNIT_TEST_ID =
  'developers_webhooks_add_business-unit-select';
export const ADD_WEBHOOK_BUSINESS_UNIT_OPTION_TEST_ID = (uuid: string) =>
  `developers_webhooks_add_business-unit-option-${uuid}`;
export const ADD_WEBHOOK_X_AUTH_TEST_ID =
  'developers_webhooks_add_x-auth-uuid-select';
export const ADD_WEBHOOK_AUTH_OPTION_TEST_ID = (uuid: string) =>
  `developers_webhooks_add_x-auth-uuid-option-${uuid}`;
export const ADD_WEBHOOK_EVENT_TEST_ID = (event: string) =>
  `developers_webhooks_add_event-checkbox-${event}`;
export const ADD_WEBHOOK_FORMAT_SELECT_TEST_ID = (event: string) =>
  `developers_webhooks_add_format-select-${event}`;
export const ADD_WEBHOOK_FORMAT_OPTION_TEST_ID = (
  event: string,
  format: string
) => `developers_webhooks_add_format-option-${event}-${format}`;
export const ADD_WEBHOOK_EVENTS_LOADING_TEST_ID =
  'developers_webhooks_add_events-loading';
export const ADD_WEBHOOK_EVENTS_ERROR_TEST_ID =
  'developers_webhooks_add_events-error';
export const ADD_WEBHOOK_SUBMIT_TEST_ID = 'developers_webhooks_add_submit-btn';
export const ADD_WEBHOOK_CANCEL_TEST_ID = 'developers_webhooks_add_cancel-btn';

export const ADD_WEBHOOK_TITLE = 'Add webhook';
export const ADD_WEBHOOK_SUBTITLE = `Create a webhook so that ${tenant.name.company} can notify your organization when events occur in our product`;
export const ENDPOINT_URL_PLACEHOLDER = 'https://';
export const BUSINESS_UNIT_PLACEHOLDER = 'Select business unit';
export const X_AUTH_PLACEHOLDER = 'Select a schema';
export const SUBSCRIBE_TO_EVENTS_LABEL = 'Subscribe to events';

export const addWebhookSuccessMessage = (count: number) =>
  count === 1 ? 'Webhook added' : 'Webhooks added';

export const alreadyActiveMessage = (events: string[]) =>
  `A webhook already exists for: ${events.join(', ')}`;

export const ADD_WEBHOOK_GENERIC_ERROR =
  'Something went wrong adding the webhook. Please try again.';

export const ADD_WEBHOOK_EVENTS_ERROR_COPY =
  'Something went wrong loading the events. Please try again.';

export const WEBHOOK_FORMAT_LABELS: Record<WebhookEventFormatsItem, string> = {
  [WebhookEventFormatsItem.json]: 'JSON',
  [WebhookEventFormatsItem.iso_20022]: 'ISO 20022'
};
